import React from 'react'
import { inject, observer } from 'mobx-react'
import { shouldShowFreeChatWindowExpiry } from 'core/freeChatWindow'

/**
 * AVN-1396 clock for the free chat window. Renders nothing: it ticks `store.now`, which drives FreeChatWindowRing, the
 * side C offer strip and the expiry popup's countdown, and shows the expiry popup once when the window runs out.
 *
 * The end time comes from the server (getConfig), so a user cannot buy themselves more time by editing anything client
 * side. Mounted unconditionally in ChatHeader, which stays mounted while the widget is minimized.
 */
@inject('store')
@observer
class FreeChatWindowTimer extends React.Component {
  componentDidMount() {
    this.tick = setInterval(() => {
      const { store } = this.props
      store.now = Math.floor(Date.now() / 1000)

      if (shouldShowFreeChatWindowExpiry(store.freeChatWindowEndsAt, store.now, store.freeChatWindowExpiryShownFor)) {
        store.freeChatWindowExpiryShownFor = store.freeChatWindowEndsAt
        store.popupType = 'freeChatWindowExpired'
      }
    }, 1000)
  }

  componentWillUnmount() {
    clearInterval(this.tick)
  }

  render() {
    return null
  }
}

export default FreeChatWindowTimer
